import { render, staticRenderFns } from "./Days.vue?vue&type=template&id=d987c1a8&"
import script from "./Days.vue?vue&type=script&lang=ts&"
export * from "./Days.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports